import CityPage from "../CityPage";

export default function OrlandPark() {
  return <CityPage slug="orland-park" />;
}
